import styles from "../index.module.scss";

const LocationComponent = ({ getData, setShowLocationList }) => {
  const maxDisplayedLocations = 10;
  const locations = getData?.locationArray || [];

  const showMoreLocations =
    locations.length > maxDisplayedLocations ? (
      <button
        className={styles.showMoreBtn}
        onClick={() => handleShowMoreClick()}
      >
        +{locations.length - maxDisplayedLocations} more
      </button>
    ) : null;

  const handleShowMoreClick = () => {
    // Handle your logic when the "+10 more" button is clicked
    // This can include showing a modal, expanding the list, etc.
    setShowLocationList(true);
  };

  return (
    <div className={styles.chipContainer}>
      {locations.slice(0, maxDisplayedLocations)?.map((obj, id) => (
        <span key={id} className={styles.chip}>
          {obj.name}
        </span>
      ))}
      {showMoreLocations}
    </div>
  );
};

export default LocationComponent;
